import { Box, Flex, Heading, Icon, Progress, Text, VStack } from '@chakra-ui/react'
import { FileText } from 'lucide-react'
import PropTypes from 'prop-types'
import { StatusOrdersCardProps } from '../interfaces/dashboard.interface'

export const StatusOrdersCard: React.FC<StatusOrdersCardProps> = ({ data }) => {
  return (
    <Box>
      <Heading as="h3" size="md" mb={4} display="flex" alignItems="center" gap={2}>
        <Icon as={FileText} /> Status das Ordens de Serviço
      </Heading>
      <VStack spacing={6} mt={8}>
        {(data ?? []).map((item, idx) => (
          <Box key={idx} w="100%">
            <Flex justifyContent="space-between" mb={2}>
              <Text fontSize="sm" fontWeight="medium">
                {item.status}
              </Text>
              <Text fontSize="sm" color="gray.500">
                {item.count} OS ({item.value}%)
              </Text>
            </Flex>
            <Progress
              value={item.value}
              size="lg"
              colorScheme={item.status === 'Pagas' ? 'green' : item.status === 'Pendentes' ? 'yellow' : 'red'}
              borderRadius="md"
            />
          </Box>
        ))}
      </VStack>
    </Box>
  )
}

// Adicionando validação de props para compatibilidade com PropTypes
// StatusOrdersCard.propTypes = {
//   data: PropTypes.arrayOf(
//     PropTypes.shape({
//       status: PropTypes.string.isRequired,
//       count: PropTypes.number.isRequired,
//       value: PropTypes.number.isRequired,
//     })
//   ).isRequired,
//   headerBgColor: PropTypes.string.isRequired,
//   gridStroke: PropTypes.string.isRequired,
//   axisStroke: PropTypes.string.isRequired,
// };

export default StatusOrdersCard
